import { SET_STEP } from '../constants/actions';

export default function setStep(user) {
  return {
    type: SET_STEP,
    payload: user
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/steps.js
 **/